import { render, staticRenderFns } from "./ReceiptsPage.vue?vue&type=template&id=47c6ea04&scoped=true&"
import script from "./ReceiptsPage.vue?vue&type=script&lang=js&"
export * from "./ReceiptsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c6ea04",
  null
  
)

export default component.exports